// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YXQK","right":"styles_right__12av8"};